import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  forwardRef,
  Injector,
  ChangeDetectorRef,
  inject,
  output,
  input,
  model,
} from '@angular/core';

import { CheckBoxModule } from '@progress/kendo-angular-inputs';
import {
  AbstractControl,
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { FloatingLabelComponent } from '@progress/kendo-angular-label';
import { cueClose, IconComponent } from '@cue/ui/icons';

@Component({
  selector: 'assist-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [ReactiveFormsModule, CheckBoxModule, IconComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements OnInit, ControlValueAccessor {
  private cdr = inject(ChangeDetectorRef);
  public floatingLabel = inject(FloatingLabelComponent, { optional: true });
  private controlContainer = inject(ControlContainer, { optional: true, host: true, skipSelf: true });
  private injector = inject(Injector);
  allowTripple = input<boolean>();
  change = output<any>();
  checked = model<boolean>();
  /**
   * Classes applied to the label element
   */
  labelClass = input<string>();
  title = input('');
  _control: AbstractControl;
  cueClose = cueClose;

  ngOnInit(): void {
    const ngControl: NgControl = this.injector.get(NgControl, null);
    if (ngControl?.control) {
      this._control = ngControl.control as FormControl<boolean>;
    } else {
      if (this.controlContainer && ngControl) {
        this._control = (this.controlContainer.control as any).get(ngControl.name);
      }
    }

    if (this._control && this.allowTripple() === true) {
      if (this.floatingLabel) {
        this.floatingLabel.focused = true;
      }
    }
  }

  focus() {
    this.cdr.markForCheck();
    if (this.floatingLabel) {
      this.floatingLabel.focused = true;
    }
  }

  blur() {
    this.cdr.markForCheck();
    if (this.floatingLabel) {
      this.floatingLabel.focused = false;
    }
  }

  registerOnChange(fn: any): void {
    this.change.subscribe(fn);
  }

  registerOnTouched(fn: any): void {}

  writeValue(obj: any): void {
    this.checked.set(obj);
    this.cdr.markForCheck();
  }

  handleChange(e: Event) {
    this.change.emit((e.target as HTMLInputElement).checked);
    e.preventDefault();
    e.stopPropagation();
  }
}
